import { render, staticRenderFns } from "./LahanDetailLogData.vue?vue&type=template&id=68df128d"
import script from "./LahanDetailLogData.vue?vue&type=script&lang=js"
export * from "./LahanDetailLogData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports